import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Stack } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { Routing } from '../../routes';
import { RootState } from '../../store';
import { SideMenu } from '../../components/side-menu/side-menu';
import { LandingPageStyle } from './landing-page-style';
import { PostAuthenticatedRoutes } from '../../routes/post-authenticated-routes';
import { HeaderBar } from '../../components/header/header-bar';
import { NavigationConfig } from '../../utils/navigation-constants';

const LandingPage: React.FC = () => {
    const location = useLocation();
    const { isLoggedIn } = useSelector((state: RootState) => state.user);
    const [open, setOpen] = React.useState(false);
    return (
        <Stack>
            {isLoggedIn ? (
                <LandingPageStyle>
                    <SideMenu menuOpen={open} menuClose={() => setOpen(false)} />
                    <Box className="body-content" px={location.pathname === NavigationConfig.Home ? 0 : 2}>
                        <HeaderBar openMenuClick={() => setOpen(true)} />
                        <PostAuthenticatedRoutes />
                    </Box>
                </LandingPageStyle>
            ) : (
                <Routing />
            )}
        </Stack>
    );
};

export { LandingPage };
